import React from 'react';

export function EmptyState({ icon: Icon, title, desc }: { icon: any; title: string; desc: string }) {
  return (
    <div style={{ padding: '32px 20px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
      <Icon size={28} color="var(--admin-card-subtext)" style={{ opacity: 0.5 }} />
      <div>
        <p style={{ fontSize: '14px', fontWeight: 600, color: 'var(--admin-card-text)', margin: '0 0 4px 0' }}>{title}</p>
        <p style={{ fontSize: '13px', color: 'var(--admin-card-subtext)', margin: 0, maxWidth: '280px' }}>{desc}</p>
      </div>
    </div>
  );
}
